<template>
  <div class="metricas-campanha-oficial-page campanhas-oficiais">
    <b-alert
      v-if="!campanhaIdValido"
      variant="warning"
      show
    >
      ID da campanha inválido na URL.
    </b-alert>

    <div
      v-else
      class="metricas-campanha__metrics-track"
    >
      <metricas-campanha-oficial-view
        :campanha-id="campanhaIdNum"
        :store-uuid="storeUuid"
      />
    </div>
  </div>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import MetricasCampanhaOficialView from './MetricasCampanhaOficialView.vue'

export default {
  name: 'MetricasCampanhaOficialPage',
  components: {
    BAlert,
    MetricasCampanhaOficialView,
  },
  computed: {
    storeUuid() {
      return this.$route.params.uuid
    },
    campanhaIdNum() {
      const n = Number(this.$route.params.campanhaId)
      return Number.isFinite(n) ? n : null
    },
    campanhaIdValido() {
      return this.campanhaIdNum != null
    },
  },
}
</script>

<style lang="scss" scoped>
/* Mesma faixa útil do `.card-body` do tema (~$card-spacer-x / 1.5rem); card e métricas são blocos separados. */
.metricas-campanha__metrics-track {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
</style>
